import { createSlice } from '@reduxjs/toolkit';

import { IPromotionalCode } from '../../pages/types';
import { fetchPromoCodes } from './promoCodes.thunk';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';

type PromoCodeState = {
  promoCodes: IPromotionalCode[];
  isLoading: boolean;
  isError: boolean;
  error: null | unknown;
  modalIsOpen: boolean;
  timer?: {
    endDate?: number;
    percentOff?: number;
  };
};

const initialState: PromoCodeState = {
  promoCodes: [],
  isLoading: false,
  isError: false,
  error: null,
  modalIsOpen: false,
};

const promoCodesSlice = createSlice({
  name: 'promoCodes',
  initialState,
  reducers: {
    addPromoCode: (state: PromoCodeState, action: PayloadAction<IPromotionalCode>) => {
      state.promoCodes.push(action.payload);
    },
    removePromoCode: (state: PromoCodeState, action: PayloadAction<string>) => {
      state.promoCodes = state.promoCodes.filter((promotionalCode) => promotionalCode.code !== action.payload);
    },
    setModalIsOpen: (state: PromoCodeState, action: PayloadAction<boolean>) => {
      state.modalIsOpen = action.payload;
    },
    setTimerData: (
      state: PromoCodeState,
      action: PayloadAction<{ endDate: number; percentOff: number } | undefined>
    ) => {
      state.timer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPromoCodes.pending, (state: PromoCodeState) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPromoCodes.fulfilled, (state: PromoCodeState, action: PayloadAction<IPromotionalCode[]>) => {
      state.isLoading = false;
      state.promoCodes = action.payload;
    });
    builder.addCase(fetchPromoCodes.rejected, (state: PromoCodeState, action: PayloadAction<unknown>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isError = true;
    });
  },
});

export const { addPromoCode, removePromoCode, setModalIsOpen, setTimerData } = promoCodesSlice.actions;
export default promoCodesSlice.reducer;
